import Component from '@glimmer/component';
import styles from './avatar.module.scss';

export default class Avatar extends Component {
  initialsFor(user) {
    const splitName = user.name.trim().split(' ');
    return splitName.reduce((acc, value, index) => {
      if (index === 0 || index === splitName.length - 1) {
        acc = `${acc}${value.charAt(0).toUpperCase()}`;
      }
      return acc;
    }, '');
  }

  get hasMultipleUsers() {
    return this.args.users && this.args.users.length > 1;
  }

  <template>
    <div
      class="{{styles.component}} avatar-container {{if this.hasMultipleUsers 'multiple-avatars'}}"
    >
      {{#each @users as |user|}}
        <span class="initials" data-test-initials>
          {{this.initialsFor user}}
        </span>
      {{/each}}
    </div>
  </template>
}
